import CustomerAPIService from "./CustomerAPIService";



class AuthService extends CustomerAPIService
{
   signin = async ({first_name, last_name, email, password, mobile_no}:any) => {

      const result = await this.post({first_name, last_name, email, password, mobile_no}, 'auth/register');
        
      return result ? result.data : null;
   }

   login = async ({email, password}:any) => {
      const result = await this.post({email, password}, 'auth/login');
        
      return result ? result.data : null;
   }

   facebookLogin = async ({accessToken}:any) => {
      const result = await this.post({accessToken}, 'auth/facebook-login');
        
      return result ? result.data : null;
   }

   logout = async (refreshToken: string) => {
      await this.post({ refreshToken }, 'auth/logout');
   }

   forgotPassword = async ({email}:any) => {
      const result = await this.post({email}, 'auth/forgot-password');
        
      return result ? result.data : null;
   }

   resetPassword = async ({token, new_password, confirm_password}:any) => {
      const result = await this.post({token, new_password, confirm_password}, 'auth/reset-password');
        
      return result ? result.data : null;
   }


   test = async () => {
      const result = await this.get('test-api-call');

      return result ? result.data : null;
}

}

export default AuthService